import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { userIsAdmin, userIsManager, userIsWorkspaceOwner } from '../../../helpers/Auth';
import { isOnboardingStepCompleted } from '../../../helpers/Onboarding';

import OnboardingStepHeader from './StepHeader';

const OnboardingInitialStep = ({ slug }) => {
  const intl = useIntl();

  const isCompleted = isOnboardingStepCompleted(slug);

  const getTitle = () => {
    if (userIsWorkspaceOwner()) {
      return intl.formatMessage({ defaultMessage: 'Create your workspace' });
    }

    if (userIsAdmin() || userIsManager()) {
      return intl.formatMessage({ defaultMessage: 'Activate your account' });
    }

    return '';
  };

  const getSubtitle = () => {
    if (userIsWorkspaceOwner()) {
      return intl.formatMessage({ defaultMessage: 'Well, that was easy!' });
    }

    if (userIsAdmin() || userIsManager()) {
      return intl.formatMessage({ defaultMessage: 'Nice work! You\'re in...' });
    }

    return '';
  };

  if (!(userIsAdmin() || userIsManager())) {
    return null;
  }

  return (
    <div className="onboarding-step">
      <OnboardingStepHeader
        title={getTitle()}
        subtitle={getSubtitle()}
        isCompleted={isCompleted}
        collapse={false}
      />
    </div>
  );
};

OnboardingInitialStep.propTypes = {
  slug: PropTypes.string.isRequired,
};

export default OnboardingInitialStep;
